/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1CoachApplication } from './V1CoachApplication'
import {
    V1CoachApplicationFromJSON,
    V1CoachApplicationFromJSONTyped,
    V1CoachApplicationToJSON,
    V1CoachApplicationToJSONTyped
} from './V1CoachApplication'

/**
 *
 * @export
 * @interface V1CoachApplicationList
 */
export interface V1CoachApplicationList {
    /**
     *
     */
    items?: Array<V1CoachApplication>
    /**
     *
     */
    page?: number
    /**
     *
     */
    perPage?: number
    /**
     *
     */
    totalItems?: number
}

/**
 * Check if a given object implements the V1CoachApplicationList interface.
 */
export function instanceOfV1CoachApplicationList(
    value: object
): value is V1CoachApplicationList {
    return true
}

export function V1CoachApplicationListFromJSON(
    json: any
): V1CoachApplicationList {
    return V1CoachApplicationListFromJSONTyped(json, false)
}

export function V1CoachApplicationListFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachApplicationList {
    if (json == null) {
        return json
    }
    return {
        items:
            json['items'] == null
                ? undefined
                : (json['items'] as Array<any>).map(V1CoachApplicationFromJSON),
        page: json['page'] == null ? undefined : json['page'],
        perPage: json['perPage'] == null ? undefined : json['perPage'],
        totalItems: json['totalItems'] == null ? undefined : json['totalItems']
    }
}

export function V1CoachApplicationListToJSON(
    json: any
): V1CoachApplicationList {
    return V1CoachApplicationListToJSONTyped(json, false)
}

export function V1CoachApplicationListToJSONTyped(
    value?: V1CoachApplicationList | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items:
            value['items'] == null
                ? undefined
                : (value['items'] as Array<any>).map(V1CoachApplicationToJSON),
        page: value['page'],
        perPage: value['perPage'],
        totalItems: value['totalItems']
    }
}
